import { TextFieldsRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';

export const QueryFilterNLSNoInputOption = () => {
  return (
    <Stack direction="row">
      <Box sx={{ px: 2 }}>
        <TextFieldsRounded color="disabled" />
      </Box>
      <Typography variant="body1" color="text.disabled">
        No text entered
      </Typography>
    </Stack>
  );
};
